import { productAxiosInstance, productAxiosInstanceWC } from "../axiosInstance";
// import { brandAxiosInstance } from "../axiosInstance";

export const getAllProducts = async () => {
  try {
    const response = await productAxiosInstance.get("/products");
    return response.data;
  } catch (error) {
    console.error("Error fetching products:", error);
    return [];
  }
}

export const getAllCategories = async () => {
  try {
    const response = await productAxiosInstance.get("/products/categories?parent=0");
    return response.data;
  } catch (error) {
    console.error("Error fetching products:", error);
    return [];
  }
}

export const getCategoryIdUsingSlug = async (slug: string) => {
  try {
    const response = await productAxiosInstance.get(`/products/categories?slug=${slug}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching products:", error);
    return [];
  }
}

export const getAllCategoryBasedProducts = async (id: number) => {
  try {
    const response = await productAxiosInstance.get(`/products?category=${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching products:", error);
    return [];
  }
}

export const getAllSubCategories = async (id: number) => {
  try {
    const response = await productAxiosInstance.get(`products/categories?parent=${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching products:", error);
    return [];
  }
}

export const getProductDetails = async (id: number) => {
  try {
    const response = await productAxiosInstance.get(`/products/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching products:", error);
    return [];
  }
}

export const getSearchProducts = async (searchTerm: string) => {
  try {
    const response = await productAxiosInstance.get(`/products`, {
      params: { search: searchTerm, search_fields: ['name'] },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching products:", error);
    return [];
  }
};

export const getAllBrandBasedProducts = async ({ brandName, pageNumber }: { brandName: string; pageNumber: number }) => {
  try {
    const response = await productAxiosInstance.get(`/products?page=${pageNumber}&limit=10&sortBy=price&order=asc&filter_brand=${brandName}`);
    return { data: response.data, headers: response.headers };
  } catch (error) {
    console.error("Error fetching products:", error);
    return { data: [], headers: {} };
  }
}

export const getAllStockStatusBasedProducts = async (stockStatus: string) => {
  try {
    const response = await productAxiosInstance.get(`/products?stock_status=${stockStatus}`);
    return {
      data: response.data,
      headers: response.headers,
    }
  } catch (error) {
    console.error("Error fetching products:", error);
    return [];
  }
}

export const getAllSortedProducts = async ({value,order}: {value: string,order: string}) => {
  try {
    const response = await productAxiosInstance.get(`/products?orderby=${value}&order=${order}`);
    return { data: response.data, headers: response.headers };
  } catch (error) {
    console.error("Error fetching products:", error);
    return { data: [], headers: {} };
  }
}

// export const getFilteredProducts = async ({
//   id,
//   brandName,
//   pageNumber,
//   stockStatus,
//   value,
//   order,
// }: {
//   id?: number;
//   brandName?: string;
//   pageNumber?: number;
//   stockStatus?: string;
//   value?: string;
//   order?: string;
// }) => {
//   try {
//     const queryParams = [];

//     if (id && pageNumber !== undefined) queryParams.push(`page=${pageNumber}&limit=10&category=${id}`);
//     if (brandName && pageNumber !== undefined)
//       queryParams.push(`page=${pageNumber}&limit=10&sortBy=price&orderby=${value}&order=${order}&filter_brand=${brandName}`);
//     if (stockStatus && pageNumber !== undefined) queryParams.push(`page=${pageNumber}&limit=10&stock_status=${stockStatus}&filter_brand=${brandName}`);
//     if (value && order && pageNumber !== undefined) queryParams.push(`page=${pageNumber}&limit=10&orderby=${value}&order=${order}`);

//     const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";

//     const endpoint = queryString ? `/products${queryString}` : "/products";

//     const response = await productAxiosInstance.get(endpoint);

//     return {
//       data: response.data,
//       headers: response.headers || {},
//     };
//   } catch (error) {
//     console.error("Error fetching products:", error);
//     return { data: [], headers: {} };
//   }
// };

export const getFilteredProducts = async ({
  id,
  brandName,
  pageNumber,
  stockStatus,
  value,
  order,
  search,
}: {
  id?: number;
  brandName?: string;
  pageNumber?: number;
  stockStatus?: string;
  value?: string;
  order?: string;
  search?: string;
}) => {
  try {
    // Using an object to ensure unique query parameters
    const queryParams: Record<string, string | number> = {
      page: pageNumber ?? 1, // Default to 1 if undefined
      limit: 10,
    };

    if (id) queryParams["category"] = id;
    if (brandName) queryParams["filter_brand"] = brandName;
    if (stockStatus) queryParams["stock_status"] = stockStatus;
    if (value && order) {
      queryParams["orderby"] = value;
      queryParams["order"] = order;
    }
    if (search) queryParams["search"] = search;

    // Convert object to query string
    const queryString = new URLSearchParams(queryParams as Record<string, string>).toString();
    const endpoint = `/products?${queryString}`;

    const response = await productAxiosInstance.get(endpoint);

    return {
      data: response.data,
      headers: response.headers || {},
    };
  } catch (error) {
    console.error("Error fetching products:", error);
    return { data: [], headers: {} };
  }
};




export const getLaunchProducts = async () => {
  try {
    const response = await productAxiosInstanceWC.get(`/products?tag=2204`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching lauch products for tag ${2204}:`, error);
    return null;
  }
};